import { AxiosInstance } from "@bps/http-client";

import { IBpIdGateway } from "./bp-id-gateway.interface";
import { CloudApplicationDto } from "./bp-id.dtos";

export class BpIdGateway implements IBpIdGateway {
  constructor(private api: AxiosInstance) {}

  public getCloudApplications = async (): Promise<CloudApplicationDto[]> => {
    return (await this.api.get("ref/cloudApplications")).data;
  };
}
